import { Link } from "react-router-dom";

export default function Community() {
  const rules = [
    { title: "Fair Play & Zero Cheating", desc: "GPS spoofing, vehicle riding during step challenges, or exploiting app glitches will result in permanent ban and loss of all earned coins." },
    { title: "Respect Fellow Warriors", desc: "No harassment, hate speech, abusive usernames, or hostile behavior in leaderboards or challenge messages. Maintain sportsman spirit." },
    { title: "Physical Safety First", desc: "Always be mindful of your surroundings while walking and capturing territories. Obey local traffic laws and do not walk in restricted or dangerous zones." },
    { title: "Authentic Profiles", desc: "Do not impersonate other users, developers, or public figures. Use authentic profile identifiers." },
  ];

  return (
    <div style={{ background: "var(--bg)", minHeight: "100vh", paddingTop: 80, overflowX: "hidden" }}>
      <style>{`
        .wb-community-section {
          padding: 80px 48px;
          max-width: 860px;
          margin: 0 auto;
        }

        /* Tablet (768px - 1024px) */
        @media (max-width: 1024px) {
          .wb-community-section {
            padding: 60px 28px;
          }
        }

        /* Mobile (< 640px) */
        @media (max-width: 640px) {
          .wb-community-section {
            padding: 48px 16px;
          }
        }
      `}</style>

      <section className="wb-community-section">
        <div style={{ marginBottom: 40 }}>
          <div style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: 11, color: "var(--neon2)", letterSpacing: 3, textTransform: "uppercase", marginBottom: 14 }}>
            🛡️ Guidelines
          </div>
          <h1 style={{ fontFamily: "'Orbitron', monospace", fontSize: "clamp(26px, 5vw, 44px)", fontWeight: 900, color: "var(--text)", marginBottom: 10, lineHeight: 1.1 }}>
            Community Guidelines
          </h1>
          <p style={{ color: "var(--muted)", fontSize: 15, lineHeight: 1.7 }}>
            WalkBattle is built on healthy competition, fitness, and mutual respect.
          </p>
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
          {rules.map((r, i) => (
            <div key={i} style={{ display: "flex", gap: 14, alignItems: "flex-start", background: "var(--surface)", border: "1px solid var(--border)", borderRadius: 10, padding: "18px 20px" }}>
              <span style={{ color: "var(--neon2)", fontFamily: "monospace", fontSize: 13, flexShrink: 0, marginTop: 2, fontWeight: 700 }}>
                0{i + 1}.
              </span>
              <div>
                <h3 style={{ fontFamily: "'Orbitron', monospace", fontSize: 15, fontWeight: 700, color: "var(--text)", marginBottom: 6 }}>
                  {r.title}
                </h3>
                <p style={{ color: "var(--muted)", fontSize: 14, lineHeight: 1.7 }}>{r.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div style={{ marginTop: 40, padding: "24px 20px", background: "rgba(0,245,196,0.04)", border: "1px solid rgba(0,245,196,0.12)", borderRadius: 10, textAlign: "center" }}>
          <p style={{ color: "var(--muted)", fontSize: 14, marginBottom: 14 }}>Report a violation or contact us</p>
          <Link to="/contact" style={{ color: "var(--neon)", fontFamily: "'Orbitron', monospace", fontSize: 11, fontWeight: 800, letterSpacing: 2, textDecoration: "none", textTransform: "uppercase" }}>
            Contact Team →
          </Link>
        </div>
      </section>
    </div>
  );
}